export function parseTrackingCoordinate(value: string | number | null | undefined): number | null {
  if (value == null) {
    return null;
  }

  const coordinate = Number(value);
  return Number.isFinite(coordinate) ? coordinate : null;
}
